import React, { useContext } from "react";
import "./BottomSubscribe.scss";
import { NavLink } from "react-router-dom";
import { DataContext } from "../../DataContext"; // Import the context

const BottomSubscribe = () => {
  const { data, loading } = useContext(DataContext);

  const payAmount = data?.payAmount || 99;

  // Show loading state
  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <section className="bottom-subscribe">
      <div className="subscribe-now-diff">
        <div className="text">
          <p className="small-font">Subscribe now & get</p>
          <p>
            <span>FREE</span> Home Delivery
          </p>
        </div>

        <NavLink to="/mybykrent" className="btn-link">          
          <div className="btn">
            PAY <b className="rupee-symbol">₹</b>{payAmount} NOW
            <span>
              {" "}
              & REMAINING ON DELIVERY
            </span>
          </div>
        </NavLink>
      </div>
    </section>
  );
};

export default BottomSubscribe;
